import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';
import { colorShade } from "utils";

const Tbl = styled.table`
  ${({ theme, displayState }) => css`
    width: 100%;
    thead, tbody tr {
      width: 100%;
    }
    
    thead th {
      position: sticky;
      top: 0;
      z-index: 1;
    }
    
    thead th:first-child {
      position: sticky;
      left:  0;
      top: 0;
      padding-left: 0px;
      z-index: 2;
    }

    tr {
      &:hover {
        td:first-child {
          background: ${displayState?.clickable ? colorShade(0.9, window?.settings?.primary_color ?? '#1DBD6B') : ''};
        }
      }
    }
    
    tbody td:first-child {
      position: sticky;
      left: 0;
      z-index: 1;
      background-color: #FFFFFF;
    }
  `}
`;

export default Wrapper(Tbl);